import { ApplicationConfig, APP_INITIALIZER, importProvidersFrom, LOCALE_ID  } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideNgxMask } from 'ngx-mask';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';

import { provideEnvironmentNgxMask } from 'ngx-mask';
import {
  MsalModule,
  MsalService,
  MsalGuard,
  MsalBroadcastService,
  MSAL_INSTANCE,
  MSAL_GUARD_CONFIG,
  MSAL_INTERCEPTOR_CONFIG
} from '@azure/msal-angular';

import { routes } from './app.routes';
import {
  msalInstance,
  MSALGuardConfigFactory,
  MSALInterceptorConfigFactory
} from './core/auth/msal.config';
import { authInterceptor } from './core/auth/interceptors/auth.interceptor';

export function initializeMsal() {
  return () => msalInstance.initialize();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideNgxMask(),
    provideHttpClient(
      withFetch(),
      withInterceptors([authInterceptor])
    ),
    provideEnvironmentNgxMask(),
    importProvidersFrom(MsalModule),
    {
      provide: MSAL_INSTANCE,
      useValue: msalInstance
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeMsal,
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    MsalService,
    MsalGuard,
    MsalBroadcastService
  ]
};